import { createContext } from 'react';

import { BusinessContextType } from '@/types';

export const BusinessDataContext = createContext<BusinessContextType>({} as BusinessContextType);
